import React, { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "../i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dscr_lang") || "en");

  useEffect(() => {
    localStorage.setItem("dscr_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));
  const c = CONTENT[lang];

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, c }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
